<template>
  <div class="user-device-location-bd ubv ub-f1">
    <div class="ub" style="margin-bottom: 24px">
      <el-button type="warning" style="margin-right: 6px" :disabled="disableJoinOrg" @click="onBindEvent" v-if="noAuth || funcView.depuser_user_join_orgdeploc">
        <i class="icon icon-tianjia"></i>
        <span>&ensp;{{ $t('ud_location_glbmxm') }}</span>
      </el-button>
      <el-button style="margin-right: 16px" :disabled="!tableSelect.length" @click="onUnbindEvent" v-if="noAuth || funcView.depuser_user_quit_orgdeploc">
        <i class="icon icon-shanchu"></i>
        <span>&ensp;{{ $t('ud_location_ycbmxm') }}</span>
      </el-button>
      <div class="ub-f1">
        <search-input width="100%" :placeholder="$t('ud_location_xmmc')" v-model="formSearch.search" @fetch="onPageChange({ page: 1 })"></search-input>
      </div>
    </div>
    <div class="table-bd ub-f1">
      <custom-table height="100%" stripe type="checkbox" tableCode="portal_user_device_assign" v-model="tableSelect" :data="tableList"></custom-table>
    </div>
    <div class="table-page">
      <custom-pagination :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-pagination>
    </div>
    <bind-department-location-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="onSuccess()"></bind-department-location-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import bindDepartmentLocationDialog from './bind_department_location_dialog.vue';

// ud_location_glbmxm: 关联部门/项目// ud_location_ycbmxm: 移出部门/项目// ud_location_xmmc: 项目名称// ud_location_nqdyycxzdglbmxmm: 您确定要移出选中的关联部门/项目吗？// ud_location_glbmxm_1: 关联部门/项目

export default {
  name: 'user_device_location',
  components: { bindDepartmentLocationDialog },
  props: {
    noAuth: {
      type: Boolean,
      default: false,
    },
    userId: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      dialogVisible: false,
      dialogModel: {},
      formSearch: {
        showSubsidiary: true,
        userId: '',
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1,
      },
      tableSelect: [],
      tableList: [],
      totalRows: 0,
    };
  },
  watch: {
    userId: function () {
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.tableList = [];
      this.totalRows = 0;
      this.getBindList();
    },
  },
  computed: {
    loginOrgId() {
      const userInfo = this.$store.state.userInfo;
      return userInfo ? userInfo.rootOrgId : '';
    },
    disableJoinOrg() {
      const curOrgId = this.loginOrgId;
      return this.tableList.findIndex(t => t.orgId === curOrgId && t.toBizType === 1) !== -1;
    },
  },
  mounted: function () {
    this.mergeLanguage(null, 'portal_user_device_location');
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getBindList();
    this.getFuncView();
  },
  methods: {
    // 获取部门/关联
    getBindList: function () {
      this.formSearch.userId = this.userId;
      this.formSearch.showSubsidiary = this.showSubsidiary;
      this.$getJSON(apis.OrganAutoBindByUser, this.formSearch).then((res) => {
        this.tableList = res.data.list || [];
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getBindList();
    },
    // 取消部门/项目
    onUnbindEvent: function () {
      this.$showConfirm(this.$t('ud_location_nqdyycxzdglbmxmm'))
        .then(() => {
          const params = this.tableSelect.map(t => ({
            orgId: t.orgId,
            bizId: t.bizId,
            bizType: t.bizType,
            toBizId: t.toBizId,
            toBizType: t.toBizType,
          }));
          this.$postJSON(apis.organDeviceBindAutoDel, params).then(() => {
            this.$message({
              message: this.$t('com_handle_success'),
              type: 'success',
            });
            this.getBindList();
            this.$emit('success');
          });
        })
        .catch(() => {});
    },
    // 关联部门/项目
    onBindEvent: function () {
      this.dialogModel.title = this.$t('ud_location_glbmxm_1');
      this.dialogModel.userId = this.userId;
      this.dialogVisible = true;
    },
    onSuccess: function () {
      this.getBindList();
      this.$emit('success');
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';
</style>
